document.addEventListener('DOMContentLoaded', () => {
  const btnsBookDemo = document.querySelectorAll(`.header-request-demo-button`);
  const linksBookDemo = document.querySelectorAll(
    `a[href='${site_url}/request-demo/']`
  );
  const btnsInfoPack = document.querySelectorAll(`.js-info-pack-button`);

  addClickEvents(
    btnsBookDemo,
    'Header Book A Demo',
    'CTA Button Click',
    '523fee9c-e65f-47d3-abbd-db72160f4c76',
    '/request-demo/thank-you/',
    'We’re here to help!',
    'Please tell us a bit about yourself<span class="br"></span> and we’ll be in touch asap.'
  );

  addClickEvents(
    linksBookDemo,
    'Content Book A Demo',
    'CTA Button Click',
    '523fee9c-e65f-47d3-abbd-db72160f4c76',
    '/request-demo/thank-you/',
    'We’re here to help!',
    'Please tell us a bit about yourself<span class="br"></span> and we’ll be in touch asap.'
  );

  addClickEvents(
    btnsInfoPack,
    'Info Pack Download',
    'CTA Button Click',
    'dc421958-c4dd-47bd-8f31-edb5ce1fa29e',
    '/info-pack-thank-you/', // AU confirmation page
    'Download the Info Pack',
    ''
  );

  const linksBookConsult = document.querySelectorAll(
    `a[href='${site_url}/book-a-consult/']`
  );
  addClickEvents(
    linksBookConsult,
    'Content Book A Demo',
    'Book A Consult Button Click',
    '725e9a71-5acd-418e-a871-d3b4bc96fc79',
    '/request-demo/thank-you/',
    'We’re here to help!',
    'Tell us a bit about yourself, and we’ll be in touch asap to arrange your business consult.'
  );

  const btnsWaitList = document.querySelectorAll(`.btn-join-the-waitlist`);
  const linksWaitList = document.querySelectorAll(`a.join-the-waitlist`);

  addClickEvents(
    [...btnsWaitList, ...linksWaitList],
    'Content Join Waitlist',
    'Join Waitlist Button Click',
    '725e9a71-5acd-418e-a871-d3b4bc96fc79',
    '/thank-you/',
    'Join the waitlist',
    'Join the waitlist for our workforce management software in ' + strCountry
  );

  const linksCustom = document.querySelectorAll(`.custom-hubspot-loader`);
  addClickEvents(
    linksCustom,
    '',
    'Hubspot Shortcode',
    '725e9a71-5acd-418e-a871-d3b4bc96fc79',
    '/request-demo/thank-you/',
    '',
    '',
    true
  );

  const linksPopForm = document.querySelectorAll(`.pop-form`);
  addClickEvents(
    linksPopForm,
    '',
    'Hubspot Shortcode',
    '725e9a71-5acd-418e-a871-d3b4bc96fc79',
    '/request-demo/thank-you/',
    '',
    '',
    true
  );
  const btnMenuTour = document.querySelectorAll(`.feature-request-tour-button`);
  const btnsHeaderTour = document.querySelectorAll(
    `.header-request-tour-button`
  );
  const btnTour = document.querySelectorAll(`.request-tour-button`);
  addClickEvents(
    [...btnsHeaderTour, ...btnTour, ...btnMenuTour],
    'Header Take The Tour',
    'CTA Button Click',
    '168ced23-b2c2-4472-b521-856be6de0348',
    '/interactive-demo/',
    'Discover Roubler for yourself',
    'Please enter your details to start the tour.'
  );

  const overlay = document.getElementById('pop-form-overlay');
  const insertPoint = overlay.querySelector('.hs-dynamic-insert');
  const close = overlay.querySelector('.pop-form-close button');
  if (close)
    close.addEventListener('click', () => {
      overlay.style.display = 'none';
    });
  const elTitle = document.getElementById('hubspot-loader-title');
  const elSubTitle = document.getElementById('hubspot-loader-text');

  function addClickEvents(
    nodes,
    evtTitle,
    evtCategory,
    formID,
    redirect,
    title,
    subTitle,
    useDataSet = false
  ) {
    [...nodes].forEach((node) => {
      node.addEventListener('click', (e) => {
        if (useDataSet) {
          render(
            e,
            evtTitle,
            evtCategory,
            e.currentTarget.dataset.formid,
            e.currentTarget.dataset.redirect,
            e.currentTarget.dataset.title.replace('{br}', '<br>'),
            e.currentTarget.dataset.text.replace('{br}', '<br>')
          );
        } else {
          render(e, evtTitle, evtCategory, formID, redirect, title, subTitle);
        }
      });
    });
  }

  function render(e, evtTitle, evtCategory, formID, redirect, title, subTitle) {
    if (e) e.preventDefault();
    elTitle.innerHTML = title;
    elSubTitle.innerHTML = subTitle;
    if (typeof ga != 'undefined') {
      ga('create', 'UA-80475308-1', 'auto');
      ga('send', 'event', {
        eventCategory: evtCategory,
        eventAction: 'click',
        eventLabel: evtTitle,
      });
    }

    const hsChatWidget = document.getElementById(
      'hubspot-messages-iframe-container'
    );
    if (hsChatWidget) {
      hsChatWidget.style.zIndex = 8000;
    }

    if (insertPoint.childElementCount === 0) {
      loadForm(formID, redirect);
    }
    overlay.style.display = 'flex';
  }

  function loadForm(formID, redirect) {
    const hsCode = `hbspt.forms.create({
        portalId: '4450450',
        formId: '${formID}', 
              translations: {
                  en: {
                      required: "This field is required.",  
                      missingSelect: "This field is required."
                  },
              },
        redirectUrl: '${site_url + redirect}'
      });
      `;

    const hsScriptNode = document.createTextNode(hsCode);
    const newScriptNode = document.createElement('script');

    newScriptNode.appendChild(hsScriptNode);
    insertPoint.appendChild(newScriptNode);
  }

  if (location.search.indexOf('show=tour') >= 0) {
    render(
      null,
      'Header Take The Tour',
      'CTA Button Click',
      '168ced23-b2c2-4472-b521-856be6de0348',
      '/interactive-demo/',
      'Discover Roubler for yourself',
      'Please enter your details to start the tour.'
    );
  }
});
